import { useId, type ReactNode } from 'react';
import styles from './FormField.module.css';

export type FormFieldProps = {
  label: string;
  required?: boolean;
  optionalLabel?: string;
  helper?: string;
  error?: string;
  children: (id: string) => ReactNode;
};

export function FormField({
  label,
  required,
  optionalLabel,
  helper,
  error,
  children,
}: FormFieldProps) {
  const id = useId();
  const descriptionId = error ? `${id}-error` : helper ? `${id}-helper` : undefined;

  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label}
        {required ? (
          <span className={styles.required} aria-hidden>
            *
          </span>
        ) : optionalLabel ? (
          <span className={styles.optional}>({optionalLabel})</span>
        ) : null}
      </label>
      {children(id)}
      {error ? (
        <p id={descriptionId} className={styles.error} role="alert">
          {error}
        </p>
      ) : helper ? (
        <p id={descriptionId} className={styles.helper}>
          {helper}
        </p>
      ) : null}
    </div>
  );
}
